import { getArticlesByCategory, getCategoryBySlug } from "@/utils/news";
import NewsCard from "@/components/feature/NewsCard";
import SectionHeading from "@/components/base/SectionHeading";

interface CategoryBlockProps {
  slug: string;
}

export default function CategoryBlock({ slug }: CategoryBlockProps) {
  const category = getCategoryBySlug(slug);
  const list = getArticlesByCategory(slug).slice(0, 3);

  if (!category || list.length === 0) return null;

  return (
    <section aria-label={category.name} className="mx-auto max-w-[1400px] px-4 md:px-6">
      <SectionHeading
        title={category.name}
        subtitle={category.desc}
        icon={category.icon}
        moreLink={`/category/${category.slug}`}
      />
      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {list.map((article) => (
          <NewsCard key={article.id} article={article} />
        ))}
      </div>
    </section>
  );
}